import { IIconBase } from '..'

const receiptDiscountIcon = ({
  color = 'black',
  height = 25,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 6.07617V8.49617C22 10.0762 21 11.0762 19.42 11.0762H16V4.08617C16 2.97617 16.91 2.07617 18.02 2.07617C19.11 2.08617 20.11 2.52617 20.83 3.24617C21.55 3.97617 22 4.97617 22 6.07617Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 7.07617V21.0762C2 21.9062 2.94 22.3762 3.6 21.8762L5.31 20.5962C5.71 20.2962 6.27 20.3362 6.63 20.6962L8.29 22.3662C8.68 22.7562 9.32 22.7562 9.71 22.3662L11.39 20.6862C11.74 20.3362 12.3 20.2962 12.69 20.5962L14.4 21.8762C15.06 22.3662 16 21.8962 16 21.0762V4.07617C16 2.97617 16.9 2.07617 18 2.07617H7H6C3 2.07617 2 3.86617 2 6.07617V7.07617Z'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.27 13.8062L11.73 8.34617'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.9247 13.5762H11.9337'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.1947 8.57617H6.20368'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default receiptDiscountIcon
